import React from 'react';
import { Platform } from 'react-native';
import PropTypes from 'prop-types';
import Button from '@/components/Buttons/Button';

const SubmitButton = ({ 
  onPress, 
  isLoading = false, 
  isDisabled = false,
  title,
  style,
  textStyle,
}) => {
  
  return (
    <Button
      text={title}
      variant={isDisabled ? "secondary" : "primary"}
      size="large"
      isLoading={isLoading}
      isDisabled={isDisabled}
      onPress={onPress}
      isFullWidth
      style={style}
      textStyle={textStyle}
      textWeight={Platform.OS === 'web' ? 'medium' : 'bold'}
    />
  );
};

SubmitButton.propTypes = {
  onPress: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  title: PropTypes.string.isRequired,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  textStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default React.memo(SubmitButton); 